import { Injectable, inject } from '@angular/core';
import { TransformComponentHandler } from './transform-component-handler';
import { ThreeJSMaterialComponentHandler } from './three-js-material-component-handler';
import { InteractiveComponentHandler } from './interactive-component-handler';
import { AmbientLightComponentHandler } from './ambient-light-component-handler';
import { SpotLightComponentHandler } from './spot-light-component-handler';

@Injectable({
  providedIn: 'root',
})
export class ComponentHandlerProvider {
  private componentHandlers = new Map<string, unknown>();

  constructor() {
    const transformComponentHandler = inject(TransformComponentHandler);
    const threeJSMaterialComponentHandler = inject(ThreeJSMaterialComponentHandler);
    const interactiveComponentHandler = inject(InteractiveComponentHandler);
    const ambientLightComponentHandler = inject(AmbientLightComponentHandler);
    const spotLightComponentHandler = inject(SpotLightComponentHandler);

    // Register library defined component handlers
    this.registerHandlerType('Transform', transformComponentHandler);
    this.registerHandlerType('ThreeJsMaterialModifier', threeJSMaterialComponentHandler);
    this.registerHandlerType('Interactive', interactiveComponentHandler);
    this.registerHandlerType('AmbientLight', ambientLightComponentHandler);
    this.registerHandlerType('SpotLight', spotLightComponentHandler);
  }

  public registerHandlerType(componentType: string, handler: unknown): void {
    this.componentHandlers.set(componentType, handler);
    // The class names for the components in the backend have a *Component -suffix. We need to account for this without
    // breaking backwards compatibility.
    this.componentHandlers.set(`${componentType}Component`, handler);
  }

  public getHandler<T = Record<string, unknown>>(componentType: string): T | undefined {
    const handler = this.componentHandlers.get(componentType) as T;
    return handler;
  }
}
